import React from "react";
// Zustand
import { useStore } from "../../zustand";
import ViewSpaceBtn from '../ButtonsUI/ViewSpaceBtn';
import BtnLaunchAR from '../ButtonsUI/BtnLaunchAR';
import CartBtn from '../ButtonsUI/CartBtn';
// Styles
import { makeStyles } from '@material-ui/core/styles';
import { billboardStyles } from "../../assets/jss/billboardStyles";
const useStyles = makeStyles(billboardStyles);

export default function VariantSwitchFooter() {
    const [state] = React.useState({ ready: true });
    const { intent } = useStore.getState().hrx;
    const { addToCartBtn } = useStore.getState().settings;
    // const dynamic_text_settings = useStore.getState().dynamic_text_settings;
    const { dynamic_text_settings } = useStore.getState().store_settings;
    const classes = useStyles(dynamic_text_settings);

    if(!state.ready) return null
    
    return (
        <section className={classes.billboard_footer}>
            <div className={classes.billboard_footer_buttons}>
                { addToCartBtn && <CartBtn /> }
                { ((intent === 'willQL') || (intent === 'canQL') || (intent === 'willSV') || (intent === 'canSV')) &&
                    <BtnLaunchAR design="billboard" />
                }
                { ((intent === 'willDQL') || (intent === 'willDSV') || (intent === 'wontDQL') || (intent === "cant")) &&
                    <ViewSpaceBtn /> 
                }
            </div>
        </section>
    );
}